import styled from 'styled-components'
import { TextContent } from "./"

export const TextGroup = styled(TextContent)`
	margin-bottom: 40px;
	&:last-child {
		margin-bottom: 0;
	}
`
